import { HTMLAttributes } from 'react';
import { Link } from '@remix-run/react';
import { useLegacyAppLink } from '../../contexts/LegacyAppLinkContext';
import type { RemixNavLinkProps } from '@remix-run/react/dist/components';

interface RoccoLinkProps
    extends HTMLAttributes<HTMLAnchorElement>,
        Pick<RemixNavLinkProps, 'prefetch'> {
    children: React.ReactNode;
    to: string;
    className?: string;
    isNonRemixRoute?: boolean;
}

export const RoccoLink = ({
    children,
    to,
    isNonRemixRoute,
    ...props
}: RoccoLinkProps) => {
    const useLegacyLink = useLegacyAppLink();

    if (useLegacyLink || isNonRemixRoute) {
        return (
            <a href={to} {...props}>
                {children}
            </a>
        );
    }

    return (
        <Link to={to} {...props}>
            {children}
        </Link>
    );
};
